import type { FactLike } from './factTypes';
import { RecordCard } from './RecordCard';

export function FactCard({ fact }: { fact: FactLike }) {
    return (
        <RecordCard
            record={{
                id: fact.id,
                recordType: fact.factType,
                recordValue: fact.factValue ?? {},
                confidenceScore: fact.confidenceScore,
                lastVerifiedAt: fact.lastVerifiedAt,
                createdAt: fact.createdAt,
            }}
            typeI18nPrefix="factTypes"
        />
    );
}
